import { themesRebrand, Theme } from '@redis-ui/styles';

// TODO - remove this when RED-179345 is done
themesRebrand.dark.components.sideBar.expanded.width = '20.4rem';

export const themeUi: Theme = themesRebrand.dark;
